module.exports = __webpack_public_path__ + "static/media/messageIntro.2139ed9f.jpg";